import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import PublicDownloadPage from './components/PublicDownloadPage'
import PublicInfoPage from './components/PublicInfoPage'
import ErrorBoundary from './components/ErrorBoundary'
import { initTheme, watchSystemTheme } from './lib/theme'
import { initTextScale } from './lib/textScale'
import './i18n'
import './theme.css'

// Тема до первого рендера — чтобы не было вспышки тёмного при светлой теме.
initTheme();
initTextScale();
// Живёт всё время работы приложения — при выбранном «Авто» подхватывает смену системной
// темы на лету (без выбора «Авто» handler просто не срабатывает, см. watchSystemTheme).
watchSystemTheme();

// После деплоя у давно открытой вкладки старый index.html ссылается на lazy-чанки (AdminPanel,
// настройки, звонки), которых на сервере уже нет (хэш в имени сменился; nginx на неизвестный путь
// отдаёт index.html). Динамический import падает, ErrorBoundary роняет всё приложение — для
// пользователя «админ-панель не запускается». Лечится перезагрузкой за свежим index.html: один
// раз за 10 секунд (sessionStorage-метка), чтобы не уйти в бесконечный цикл при реальной поломке.
window.addEventListener('vite:preloadError', (event) => {
  const KEY = 'preloadReloadAt';
  try {
    const last = Number(sessionStorage.getItem(KEY) ?? 0);
    if (Date.now() - last < 10_000) return;
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    /* sessionStorage недоступен — всё равно один раз перезагрузимся */
  }
  event.preventDefault();
  window.location.reload();
});

// Публичные страницы (/download, /info) рендерятся без App: их открывают без входа в мессенджер.
const publicPath = window.location.pathname.replace(/\/+$/, '');
const publicPage = publicPath === '/download'
  ? <PublicDownloadPage />
  : publicPath === '/info'
    ? <PublicInfoPage />
    : null;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {publicPage ?? (
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    )}
  </React.StrictMode>,
)
